export default [
  {
    path: '/tenant/theming',
    name: 'TenantThemeSettings',
    meta: {
        title: 'Tenant Theming'
    },
    component: function() {
        return import( /* webpackChunkName: "tenant" */ '../views/Tenant/theming.vue')
    },
}
]